import React from "react";

const Priority = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M2 2h32v8H2zM2 14h22v8H2zM2 26h12v8H2z"
            fill={fill}
        />
    </svg>
);

export default Priority;
